module.exports = __webpack_public_path__ + "static/img/blog-img4.e0dcba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-img4.jpg
// module id = F8Mk
// module chunks = 1